import { useSelector } from 'react-redux';

import type { RootState } from '../../../store';

export const useClaimBuilderSelectors = () => {
  const {
    selectedClientFacility,
    selectedClientPlans,
    paDetailsLoading,
    selectedPolicyPriorAuthorizationDetails,
    selectedClientPolicyLoading,
    facilityAssignmentsLoading,
  } = useSelector((state: RootState) => state.clients);
  const { providerLicensesLoading, providerPayorCredentialsLoading } = useSelector(
    (state: RootState) => state.providers,
  );
  const { clientCohortAssignments } = useSelector((state: RootState) => state.cohorts);

  return {
    selectedClientFacility,
    selectedClientPlans,
    paDetailsLoading,
    clientDeatilsLoading: selectedClientPolicyLoading || facilityAssignmentsLoading,
    selectedPolicyPriorAuthorizationDetails,
    providerLicensesLoading,
    providerPayorCredentialsLoading,
    clientCohortAssignments,
  };
};
